export type ValidationResult = { valid: true | false; message: string };

export const validateAdminPayment = (
  previousYDiscount: number,
  currentYDiscount: number,
  amountPaying: number,
  balanceAmount: number,
  previousTotalDue: number,
): ValidationResult => {
  if (amountPaying <= 0) {
    return { valid: false, message: `Amount should be greater than 0` };
  }
  if (previousYDiscount > previousTotalDue) {
    return { valid: false, message: `Previous year discount cannot be greater than ${previousTotalDue}` };
  }

  const currentYearBalance = balanceAmount - previousTotalDue;
  if (currentYDiscount > currentYearBalance) {
    return { valid: false, message: `Current year discount cannot be greater than ${currentYearBalance}` };
  }

  if (previousYDiscount + currentYDiscount + amountPaying > balanceAmount) {
    return { valid: false, message: `Discount and amount paying should not exceed balance amount ${balanceAmount}` };
  }

  if (amountPaying + previousYDiscount + currentYDiscount <= 0) {
    return { valid: false, message: "Amount should be greater than 0" };
  }

  return { valid: true, message: "no-errors" };
};

export {};
